import * as React from 'react'
import { IOWidget, Updater, fromJSX } from 'widgets-for-react'
import { Form } from '../../../../form'
import { FormState } from '../../../../form/types'
import { CMSState } from '../../../drupalPage/state'

export type formBlockProps = {
  block_index: number
  form_id: string
  state: FormState
}

export type formBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
}>

export const formBlock =
  (
    { state, block_index }: formBlockProps,
    options?: { style: formBlockStyle; key?: string }
  ): IOWidget<CMSState, Updater<CMSState>> =>
  () =>
    fromJSX((setState) => (
      <section className="block block--form">
        <div className="block__inner container container--s grid--block">
          <div className="block__content">
            {Form(state).run((updater) => {
              setState((state) => {
                let currentBlock = state.blocks.get(block_index)
                if (currentBlock == undefined) return state
                if (currentBlock.kind === 'formBlock') {
                  const newState = updater(currentBlock.value[0].state)

                  if (newState.form_submission_logic.kind == 'loaded')
                    if (!window.dataLayer.find((layer) => layer.action == 'Form'))
                      window.dataLayer.push({
                        event: 'event.refresco',
                        category: 'Contact',
                        action: 'Form',
                        label: window.location.pathname
                      })

                  currentBlock = {
                    ...currentBlock,
                    value: [{ ...currentBlock.value[0], state: newState }, currentBlock.value[1]]
                  }
                }
                return { ...state, blocks: state.blocks.set(block_index, currentBlock) }
              })
            })}
          </div>
        </div>
      </section>
    ))
